{
	"forms": {
		"minimum_value_is": "Minimivärdet är {{val}}",
		"maximum_value_is": "Maximivärdet är {{val}}"
	},
	"general": {
		"true": "Ja",
		"login": "Logga in",
		"email": "E-post",
		"password": "Lösenord",
		"error_connecting_to_server": "Fel vid anslutning till servern",
		"required": "Obligatoriskt",
		"logging_in": "Loggar in...",
		"something_went_wrong": "Något gick fel",
		"forgot_your_password": "Glömt ditt lösenord?",
		"register": "Registrera",
		"send_message": "Skicka meddelande",
		"message_history": "Meddelandehistorik",
		"contacts": "Kontakter",
		"credits": "Krediter",
		"account": "Konto",
		"customer_service": "Kundtjänst",
		"log_out": "Logga ut",
		"really_log_out": "Är du säker på att du vill logga ut?",
		"cancel": "Avbryt",
		"loading": "Laddar...",
		"expiring_information": "Köpta krediter upphör att gälla ett år från köpdatumet. Krediternas utgång kan förhindras genom att köpa ytterligare krediter.",
		"home": "Hem",
		"welcome_use_tavoittaja": "Välkommen till Tavoittaja",
		"credits_to_use": "krediter",
		"buy_credits": "Köp krediter",
		"send_message_guide": "Du kan skicka textmeddelanden till dina sparade grupper eller ange mottagarna manuellt. Du kan också schemalägga meddelandet för senare leverans. Se till att du har tillräckligt med krediter på ditt konto innan du skapar meddelandet så att det kan skickas.",
		"did_you_know": "Visste du att...",
		"continue_to_confirm": "Bekräfta",
		"sender": "Avsändare",
		"message": "Meddelande",
		"credits_per_message": "krediter per meddelande",
		"characters": "tecken",
		"receivers": "Mottagare",
		"groups": "Grupper",
		"subject": "Ämne",
		"send_message_to_customer_service": "Skicka meddelande till kundtjänst",
		"customer_service_info_text": "Här kan du kontakta vår kundtjänst med formuläret nedan.",
		"phone_number_short": "Telefon",
		"support_open_times": "(mån - fre 09.00–17.00)",
		"service_is_owned_by": "Tavoittaja drivs av",
		"thanks_for_message": "Tack!",
		"we_will_contact_asap": "Vi kontaktar dig så snart som möjligt.",
		"account_guide": "Kom ihåg att hålla kontoinformationen uppdaterad.",
		"first_name": "Förnamn",
		"inbound_numbers": "Avsändarnummer",
		"last_name": "Efternamn",
		"phone": "Telefonnummer",
		"save": "Spara",
		"account_information": "Kontoinformation",
		"name": "Namn",
		"businessID": "Organisationsnummer",
		"city": "Stad",
		"postal_code": "Postnummer",
		"postal_address": "Postadress",
		"saved": "Sparad",
		"please_wait": "Vänligen vänta...",
		"oops_something_went_wrong": "Oj! Något gick fel",
		"unexpected_error": "Ett oväntat fel inträffade.",
		"we_are_informed": "Vi har informerats om detta fel och kommer att åtgärda det så snart som möjligt.",
		"reload_page": "Ladda om sidan",
		"new_password": "Nytt lösenord",
		"new_password_again": "Nytt lösenord igen",
		"change_your_accounts_password": "Byt lösenord för ditt konto",
		"password_guide": "När du skapar ett nytt lösenord, se till att det är minst 6 tecken långt. Försök att använda en kombination av siffror, bokstäver och skiljetecken.",
		"change_password": "Byt lösenord",
		"api": "API",
		"users": "Användare",
		"passwords_do_not_match": "Lösenorden matchar inte",
		"select_credit_amount": "Välj antal krediter",
		"select_amount_manually": "Eller ange belopp manuellt",
		"amount_short": "st",
		"select_payment_method": "Välj betalningsmetod",
		"online_payment": "Onlinebetalning (Paytrail)",
		"payment_details": "Betalningsinformation",
		"price_without_vat": "Pris exkl. moms",
		"vat": "Moms 25.5%",
		"payment_fee": "Fakturaavgift",
		"total": "Totalt",
		"use_discount_code": "Använd rabattkod",
		"continue_to_pay": "Betala",
		"buy_atleast_500_credits": "Du måste köpa minst 500 krediter.",
		"enter_code": "Ange kod",
		"apply": "Tillämpa",
		"discount_applied": "Rabatt tillämpad",
		"buy_credits_guide": "Du behöver krediter för att skicka textmeddelanden. En kredit motsvarar ett standardlångt textmeddelande. Du kan betala köpet via onlinebetalning eller faktura. Krediterna är giltiga i 365 dagar från inköpstillfället.",
		"credit_buy_history": "Historik",
		"history_guide": "Nedan kan du se köphistorik för krediter.",
		"select_account": "Välj vilket konto du vill logga in som",
		"password_must_be_at_least_8_characters": "Lösenordet måste vara minst 8 tecken långt.",
		"account_has_credits": "Du har för närvarande {{credits}} krediter.",
		"admin": "Admin",
		"oops_not_found": "Oj! Sidan du söker finns inte.",
		"this_page_does_not_exist": "Det verkar som att du har gått vilse. Låt oss hjälpa dig hitta rätt.",
		"go_to_homepage": "Gå till startsidan",
		"phone_in_international_format": "Telefonnummer i internationellt format (+358 123 456 789)",
		"recover_password": "Återställ lösenord",
		"recover_password_guide": "Ange den e-postadress som är kopplad till ditt konto så skickar vi ett e-postmeddelande med en länk för att återställa lösenordet.",
		"go_back": "Gå tillbaka",
		"send_recovery_email": "Skicka återställningsmejl",
		"check_your_email": "Kontrollera din e-post",
		"we_have_sent_recovery_details": "Om ett konto med den e-postadressen finns har vi skickat en återställningslänk till din e-post.",
		"back_to_login": "Tillbaka",
		"set_a_password": "Skapa ett nytt lösenord",
		"invalid_token": "Ogiltig token. Kontrollera att du kopierat hela länken.",
		"password_recovery_done": "Klart. Du kan nu logga in med det nya lösenordet.",
		"register_guide_1": "Att komma igång med tjänsten är snabbt och gratis.",
		"credit_offer": "Erbjudandet om 100 krediter gäller endast nya företags- och föreningskunder. Du kommer att få krediterna när vi har godkänt ditt konto.",
		"you_must_represent_organization": "Obs! Du måste ha befogenhet att företräda organisationen i vars namn kontot registreras.",
		"password_again": "Lösenord igen",
		"organization": "Företag/förening",
		"really_go_back": "Du har inte registrerat dig ännu. Vill du verkligen gå tillbaka?",
		"have_read_terms": "Jag har läst och accepterat ",
		"service_is_meant_for": "Tjänsten är avsedd för kommunikation och marknadsföring av företag och organisationer. Den är inte avsedd för kommunikation mellan privatpersoner.",
		"terms_and_conditions": "villkoren",
		"no_account_yet": "Inget konto? ",
		"register_done": "Registreringen lyckades! Vi kommer att granska din registrering och meddela dig när ditt konto har aktiverats.",
		"register_successful": "Registreringen lyckades",
		"personal_information": "Personuppgifter",
		"create_user": "Skapa användare",
		"create_user_successful": "Användare skapades framgångsrikt",
		"you_can_now_login": "Du kan nu logga in.",
		"inbound_numbers_guide": "Aktivera tvåvägskommunikation genom att reservera ett eget avsändarnummer. När du skickar ett meddelande från ditt reserverade nummer kan mottagaren svara på meddelandet.",
		"contact_customer_service_to_order_inbound_number": "Inkommande nummer kostar 49 € per månad exklusive moms.",
		"api_guide": "Du kan också integrera SMS-utskick i dina egna system med hjälp av API-uppgifter.",
		"contact_email": "Kontaktens e-postadress",
		"contact_email_guide": "Om vi gör ändringar i API:t kommer vi att meddela denna e-postadress.",
		"guide": "Instruktioner",
		"company": "Företag",
		"sort_asc": "Sortera stigande",
		"sort_desc": "Sortera fallande",
		"choose_visible_columns": "Välj synliga kolumner",
		"search": "Sök",
		"clear": "Tömma",
		"paytrail_payment_terms": "Paytrail betalningsvillkor",
		"no_data": "Ingen data",
		"time_created": "Tid skapad",
		"vat_code": "Momsnummer",
		"billing_email": "E-postadress dit orderbekräftelser och kvitton skickas",
		"billing_email_with_invoicing": "E-postadress dit orderbekräftelser, kvitton och eventuella fakturor skickas",
		"order": "Beställning",
		"order_id": "Beställnings-ID",
		"product_info": "Produktinformation",
		"total_without_vat": "Totalt utan moms",
		"payment_method": "Betalningsmetod",
		"invoice": "Faktura",
		"receiver": "Mottagare",
		"payer": "Betalare",
		"buy_date": "Köpdagen",
		"product": "Produkt",
		"open_receipt": "Öppna kvitto",
		"price_does_not_include_vat": "(Pris inkluderar inte moms 25,5%)",
		"regular": "Vanlig användare",
		"role": "Roll",
		"users_guide": "Bläddra, lägg till, redigera och ta bort användare och deras information.",
		"edit": "Redigera",
		"is_admin": "Är administratör",
		"cannot_edit_your_own_role": "Du kan inte ändra din egen roll.",
		"you_can_only_edit_other_users_role": "Du kan bara ändra andra användares roll.",
		"remove_from_account": "Ta bort",
		"remove": "Ta bort",
		"remove_user": "Ta bort användare",
		"really_remove_user": "Vill du verkligen ta bort den här användaren från ditt konto?",
		"add_user": "Lägg till användare",
		"job_title": "Yrkesbeteckning",
		"import_from_file": "Importera från fil",
		"custom_fields": "Anpassade fält",
		"message_templates": "Meddelandemallar",
		"schedule_send": "Schemalägg utskick",
		"manual_receivers_guide": "Skriv varje nummer på en egen rad eller separera dem med kommatecken.",
		"click_to_set_date_and_time": "Klicka för att ställa in datum och tid",
		"message_templates_guide": "Meddelandemallar",
		"contacts_amount": "kontakter",
		"contact_amount": "kontakt",
		"groups.with_0_contacts_are_not_shown": "Grupper utan kontakter kan inte väljas.",
		"send_now": "Skicka nu",
		"send": "Skicka",
		"character_count": "Antal tecken",
		"drafts": "Utkast",
		"drafts_guide": "Utkast",
		"message_must_have_at_least_one_recipient": "Meddelandet måste ha minst en mottagare",
		"confirm_details": "Bekräfta uppgifter",
		"confirm_details_guide": "Se till att allt är korrekt innan du skickar meddelandet.",
		"back": "Tillbaka",
		"selected": "valda",
		"remove_message": "Ta bort utkast",
		"really_remove_message": "Vill du verkligen ta bort detta utkast?",
		"deleted": "Borttaget",
		"none_selected": "Ingen vald",
		"selected_rows": "Använda valda",
		"delete_selected": "Ta bort valda",
		"remove_messages": "Ta bort utkast",
		"really_remove_messages": "Vill du verkligen ta bort valda utkast?",
		"remove_users": "Ta bort användare",
		"really_remove_users": "Vill du verkligen ta bort valda användare?",
		"delete": "Borttag",
		"receiver_groups": "Mottagargrupper",
		"receiver_manual_contacts": "Manuella mottagarnummer",
		"sent_messages_guide": "Här kan du se information om dina skickade meddelanden. Klicka på ett meddelande för att se en detaljerad leveransrapport. Mottagarinformation sparas för innevarande och föregående kalenderår.",
		"sent_messages": "Meddelandehistorik",
		"status_draft": "Utkast",
		"status_scheduled": "Schemalagd",
		"status_waiting_to_be_sent": "Väntar på att skickas",
		"status_ongoing": "Pågående",
		"status_completed": "Slutförd",
		"status_error": "Fel",
		"status_unknown": "Okänd",
		"successful_sends": "Skickade",
		"waiting_to_be_sent_count": "Väntar på att skickas",
		"status": "Status",
		"time_sent": "Skickat tid",
		"single_message_history": "Meddelandedetaljer",
		"single_message_history_guide": "Nedan kan du se en detaljerad leveransrapport.",
		"is_scheduled": "Schemalagd",
		"yes": "Ja",
		"no": "Nej",
		"error_details": "Felinformation",
		"errors": "Fel",
		"details_do_not_update_in_real_time": "Meddelandedetaljer uppdateras inte i realtid. Uppdatera sidan för att se de senaste uppgifterna.",
		"not_sent": "Inte skickat",
		"user_will_receive_an_email": "Den tillagda användaren kommer att få ett mejl med en länk för att fylla i sin information.",
		"overview": "Översikt",
		"recipient_details": "Mottagaruppgifter",
		"sent": "Skickat",
		"sending": "Skickar",
		"information": "Mer information",
		"time_delivered": "Tid levererad",
		"not_delivered": "Ej levererat",
		"continue": "Fortsätt",
		"inactive": "Inaktiv",
		"active": "Aktiv",
		"blocked": "Blockerad",
		"select_substitutions": "Anpassa meddelandet",
		"inactive_contacts_on_receivers": "Inaktiva eller blockerade kontakter",
		"inactive_contacts_on_receivers_guide": "Dessa mottagare som du har lagt till är inaktiva eller blockerade och kommer inte att få meddelandet:",
		"expected": "förväntad",
		"add_marketing_block": "Lägg till länk för att neka marknadsföring",
		"adding_marketing_block": "Lägger till marknadsföringsblockering",
		"marketing_block_guide_1": "Du kan lägga till en personlig länk i dina meddelanden som gör det möjligt för mottagaren att lägga till sitt telefonnummer i en spärrlista. Nummer som läggs till i spärrlistan kommer inte längre att få meddelanden från ditt användarkonto.",
		"marketing_block_guide_2": "Hej, idag får lojalitetskunder 20 % rabatt på alla produkter. Neka marknadsföring {{stopLink}}",
		"marketing_block_guide_3": "I exemplet ovan ersätts termen {{stopLink}} med en mottagarspecifik URL som gör det möjligt för personen att blockera marknadsföring. URL:en är 27 tecken lång och detta antal tecken dras från det totala tillgängliga antalet. URL:en har formatet tavoittaja.fi/s/xxxxxxxx/xx.",
		"marketing_block_guide_4": "Tjänsten är gratis för alla våra kunder.",
		"add": "Lägg till avregistreringslänk",
		"custom_fields_guide": "Anpassade fält",
		"label": "Namn",
		"add_custom_field": "Lägg till anpassat fält",
		"remove_custom_field": "Ta bort anpassat fält",
		"really_remove_custom_field": "Vill du verkligen ta bort det här anpassade fältet?",
		"error_occurred": "Ett fel inträffade",
		"drag_and_drop_file_here": "Tryck här eller dra och släpp filen här",
		"supported_file_types": "Filtyper som stöds",
		"upload_file": "Ladda upp fil",
		"choose_columns": "Välj kolumner",
		"confirm_import": "Bekräfta import",
		"start_over": "Börja om",
		"previous": "Föregående",
		"next": "Nästa",
		"map_to_column": "Koppla till kolumn",
		"column_data": "Kolumndata",
		"description": "Beskrivning",
		"ignore": "Ignorera",
		"select": "Välj",
		"imports": "Importer",
		"original_file_name": "Ursprungligt filnamn",
		"error_message": "Felmeddelande",
		"remove_contact": "Ta bort kontakt",
		"really_remove_contact": "Vill du verkligen ta bort denna kontakt?",
		"removed": "Borttagen",
		"remove_contacts": "Ta bort kontakter",
		"really_remove_contacts": "Vill du verkligen ta bort valda kontakter?",
		"remove_groups": "Ta bort grupper",
		"really_remove_groups": "Vill du verkligen ta bort valda grupper?",
		"really_remove_group": "Vill du verkligen ta bort denna grupp?",
		"remove_group": "Ta bort grupp",
		"no_custom_fields_found": "Inga anpassade fält hittades",
		"no_contacts_found": "Inga kontakter hittades, börja med att skapa eller importera kontakter",
		"no_groups_found": "Inga grupper hittades",
		"no_imports_found": "Inga importer hittades",
		"no_orders_found": "Inga beställningar hittades",
		"no_messages_found": "Inga meddelanden hittades",
		"no_recipients_found": "Inga mottagare hittades",
		"no_drafts_found": "Inga utkast hittades",
		"no_inbound_numbers_found": "Inga inkommande nummer hittades",
		"no_users_found": "Inga användare hittades",
		"no_search_results_with": "Inga sökresultat för",
		"superadmin_login": "Superadmin-inloggning",
		"superadmin": "Superadmin",
		"sms_messages": "SMS-meddelanden",
		"accounts": "Konton",
		"orders": "Beställningar",
		"accounts_guide": "Här kan du logga in på konton, lägga till krediter på konton eller ta bort dem.",
		"waiting_for_approval": "Väntar på godkännande",
		"rejected": "Avslagen",
		"approved": "Godkänd",
		"locked": "Låst",
		"unknown": "Okänd",
		"business_id": "Organisationsnummer",
		"remove_accounts": "Ta bort valda konton",
		"really_remove_accounts": "Är du säker på att du vill ta bort de valda kontona?",
		"no_accounts_found": "Inga konton hittades",
		"login_to_account": "Logga in på konto",
		"logged_in_as": "Inloggad som",
		"accounts_waiting_for_approval": "Dessa konton väntar på godkännande",
		"no_new_registered_accounts_waiting_for_approval": "Inga nya konton väntar på godkännande.",
		"approve": "Godkänn",
		"dont_approve": "Godkänn inte",
		"time_modified": "Senast ändrad",
		"remove_custom_fields": "Ta bort anpassade fält",
		"really_remove_custom_fields": "Vill du verkligen ta bort de valda anpassade fälten?",
		"custom_fields_info_text": "Du kan lägga till och redigera fält under fliken Anpassade fält",
		"no_custom_fields": "Inga anpassade fält",
		"basic_information": "Grundinformation",
		"edit_contact": "Redigera kontakt",
		"time_latest_login": "Senaste inloggningstid",
		"never_logged_in": "Aldrig inloggad",
		"used_credits": "Krediter",
		"unsubscribe": "Neka marknadsföring",
		"subscribe": "Tillåt marknadsföring",
		"really_unsubscribe": "Blockera marknadsföring från {{account}} till nummer {{number}}?",
		"really_subscribe": "Tillåt marknadsföring från {{account}} till nummer {{number}}?",
		"subscribe_success": "Marknadsföring tillåten!",
		"unsubscribe_success": "Marknadsföring blockerad!",
		"filters": "Filter",
		"close": "Stäng",
		"clear_all_filters": "Rensa alla filter",
		"invalid_sender": "Avsändarens namn kan vara upp till 11 tecken långt och får endast innehålla bokstäver, siffror och mellanslag (inga accenter) eller ett telefonnummer.",
		"open_order": "Öppna beställning",
		"download_receipt": "Ladda ner som PDF",
		"generating_pdf": "Genererar PDF...",
		"after": "Efter",
		"before": "Före",
		"select_date": "Välj datum",
		"no_items": "Inga objekt",
		"marketing_block": "Länk för att avsluta marknadsföring",
		"adding_manual_entries_to_contacts_list": "Nya nummer",
		"adding_manual_entries_to_contacts_list_guide": "Du har manuellt lagt till nummer som inte är sparade i dina kontakter. Nu kan du lägga till mer information så att de går att hitta senare, till exempel via namn.",
		"add_details": "Lägg till uppgifter",
		"done": "Jag har lagt till de uppgifter jag ville",
		"general_fields": "Allmänna fält",
		"go_back_to_previous_page": "Tillbaka till föregående sida",
		"no_groups": "Inga grupper",
		"add_to_groups": "Lägg till i grupper",
		"add_selected_contacts_to_groups": "Den här åtgärden lägger till de valda kontakterna i de valda grupperna.",
		"choose_groups": "Välj grupper",
		"remove_from_groups": "Ta bort från grupper",
		"remove_selected_contacts_from_groups": "Den här åtgärden tar bort de valda kontakterna från de valda grupperna.",
		"reject_account": "Avvisa konto",
		"really_reject_account": "Vill du verkligen avslå kontot? Skriv orsaken till avslaget nedan.",
		"reject": "Avvisa",
		"approve_account": "Godkänn användare",
		"really_approve_account": "Vill du godkänna användaren?",
		"remove_account": "Ta bort konto",
		"really_remove_account": "Vill du verkligen ta bort detta konto?",
		"account_access": "Konto",
		"superadmins": "Superadmins",
		"superadmins_guide": "Lägg till, ändra och ta bort superadministratörer.",
		"add_superadmin": "Lägg till superadministratör",
		"discount_codes": "Rabattkoder",
		"time_start": "Starttid",
		"time_end": "Sluttid",
		"no_discount_codes_found": "Inga rabattkoder hittades",
		"code": "Kod",
		"discount_percentage": "Rabattprocent",
		"usage_limit": "Användningsgräns",
		"add_discount_code": "Lägg till rabattkod",
		"leave_empty_for_no_limit": "Lämna tomt för ingen begränsning",
		"monthly_sales": "Månadsförsäljning",
		"january": "Januari",
		"february": "Februari",
		"march": "Mars",
		"april": "April",
		"may": "Maj",
		"june": "Juni",
		"july": "Juli",
		"august": "Augusti",
		"september": "September",
		"october": "Oktober",
		"november": "November",
		"december": "December",
		"monthly_credits_spent": "Månadsvis förbrukade krediter",
		"monthly_messages_sent": "Månadsvis skickade meddelanden",
		"getting_started": "Kom igång",
		"here_is_how_to_get_started": "Välkommen att använda Tavoittaja. Så här kommer du igång:",
		"buy_credits_guide_step": "Köp krediter",
		"buy_credits_desc": "Du behöver krediter för att skicka meddelanden. En tumregel är att ett meddelande kostar en kredit.",
		"add_contacts_guide_step": "Lägg till kontakter",
		"add_contacts_desc": "Lägg till eller importera kontakter som du vill skicka meddelanden till.",
		"send_message_guide_step": "Skicka ditt första meddelande",
		"send_message_guide_desc": "När du har gjort de tidigare stegen är du redo att skicka dina första meddelanden!",
		"no_sms_message_templates_found": "Inga SMS-meddelandemallar hittades",
		"remove_message_templates": "Ta bort meddelandemallar",
		"really_remove_message_templates": "Är du säker på att du vill ta bort de valda meddelandemallarna?",
		"time_latest_message_sent": "Tid för senaste meddelande skickat",
		"time_credits_expire": "Krediter upphör",
		"id": "ID",
		"edit_superadmin": "Redigera superadmin",
		"announcements": "Meddelanden",
		"announcements_guide": "Tekniska bulletiner och meddelanden om tjänsteuppdateringar.",
		"no_announcements": "Inga meddelanden",
		"title": "Titel",
		"content": "Innehåll",
		"news": "Nyhet",
		"change_log": "Uppdatering",
		"remove_announcement": "Ta bort meddelande",
		"really_remove_announcement": "Är du säker på att du vill ta bort detta meddelande?",
		"remove_announcements": "Ta bort meddelanden",
		"type": "Typ",
		"no_announcements_found": "Inga meddelanden hittades",
		"add_announcement": "Lägg till meddelande",
		"really_remove_announcements": "Är du säker på att du vill ta bort de valda meddelandena?",
		"payment_status": "Betalningsstatus",
		"unable_to_fetch_announcements": "Det gick inte att hämta meddelanden",
		"save_changes": "Spara ändringar",
		"expected_credit_usage": "Krediter",
		"not_enough_credits": "Inte tillräckligt med krediter",
		"add_or_remove_credits": "Lägg till eller ta bort krediter",
		"modify_credits": "Lägg till eller ta bort krediter",
		"add_credits": "Lägg till",
		"remove_credits": "Ta bort",
		"amount": "Belopp",
		"credits_removed": "Krediter borttagna",
		"credits_added": "Krediter tillagda",
		"monthly_accounts_created": "Nya konton",
		"add_message_template": "Lägg till meddelandemall",
		"add_sms_message_template": "Lägg till meddelandemall",
		"really_remove_sms_message_template": "Vill du verkligen ta bort meddelandemallen?",
		"remove_sms_message_template": "Ta bort meddelandemall",
		"sms_message_template_added": "Meddelandemall skapad",
		"send_message_using_template": "Skicka meddelande med mall",
		"users_name": "Användarens namn",
		"users_phone": "Användarens telefonnummer",
		"users_email": "Användarens e-postadress",
		"i_just_tried_to_do_something_very_silly": "I just tried to do something very silly!",
		"use_as_template": "Använd som mall",
		"threshold": "Antal krediter",
		"price_per_credit": "Pris per kredit",
		"pricing": "Prissättning",
		"more_you_buy_cheaper": "Ju fler du köper, desto billigare blir krediterna.",
		"active_description": "Vanlig status. Denna kontakt kan ta emot sms.",
		"inactive_description": "Denna kontakt ska inte längre ta emot sms.",
		"blocked_description": "Mottagaren har avslutat prenumerationen och ska inte få några sms.",
		"time_active_start": "Aktiv från",
		"time_active_end": "Aktiv till",
		"active_reservation": "Används på kontot",
		"add_inbound_number": "Lägg till inkommande nummer",
		"edit_inbound_number": "Redigera inkommande nummer",
		"no_active_reservation": "Inte i bruk",
		"is_enabled": "Aktiverad",
		"click_to_select_date": "Klicka för att välja datum",
		"inbound_number_reservations": "Reservationer för inkommande nummer",
		"add_inbound_number_reservation": "Lägg till reservation",
		"no_inbound_number_reservations_found": "Inga reservationer hittades",
		"inbound_number": "Inkommande nummer",
		"edit_inbound_number_reservation": "Redigera reservation",
		"messaging_history": "Meddelandehistorik",
		"message_from_contact": "Meddelande från kontakt",
		"message_to_contact": "Meddelande till kontakt",
		"message_name": "Meddelandets namn",
		"inbound_messages": "Inkommande meddelanden",
		"inbound_messages_desc": "Meddelanden som mottagits till sändarnummer visas här.",
		"export": "Exportera till Excel-fil",
		"time_received_before": "Mottaget före",
		"time_scheduled": "Schemalagd att avgå",
		"not_scheduled": "Inte schemalagd",
		"number_of_contacts": "Kontakter i gruppen",
		"select_columns_to_export": "Välj kolumner att exportera",
		"time_unsubscribed": "Marknadsföringsavanmälan inställd",
		"created_from": "Skapad från",
		"select_all": "Välj alla",
		"api_key_generated": "Din API-nyckel har skapats. Kopiera och spara den på ett säkert ställe nu – du kommer inte att kunna se den igen.",
		"copied_to_clipboard": "Kopierat till urklipp",
		"generate_api_key": "Skapa API-nyckel",
		"generate": "Skapa",
		"surveys": "Enkäter",
		"add_survey": "Skapa enkät",
		"no_surveys_found": "Inga enkäter hittades",
		"time_submit_start": "Schemalagd att öppnas",
		"time_submit_end": "Schemalagd att stängas",
		"surveys_guide": "Du kan skapa enkäter, till exempel för att samla in feedback.",
		"add_survey_guide": "Du kan redigera informationen du angav när du skapade enkäten senare under fliken Inställningar.",
		"create": "Skapa",
		"draft": "Utkast",
		"submissions": "Svar",
		"edit_fields": "Redigera fält",
		"reports": "Rapporter",
		"settings": "Inställningar",
		"submissions_guide": "Bläddra igenom dina enkätresultat i listan nedan. Du kan exportera alla svar till en Excel-fil genom att klicka på Exportera till Excel-knappen.",
		"no_submissions_found": "Inga svar",
		"edit_fields_guide": "Du kan lägga till nya fält i din enkät genom att dra dem från kolumnen till höger. Redigera ett fält genom att klicka på dess penna-ikon.",
		"default_fields": "Standardfält",
		"multiple_choices": "Flerval",
		"open_answers": "Öppna svar",
		"ratings": "Betygsskala",
		"survey_structure": "Enkätstruktur",
		"choose_one": "Välj ett",
		"text": "Textfält",
		"number": "Nummerfält",
		"date": "Datum",
		"smiley": "Smileys",
		"star": "Stärjna",
		"scale": "Betyg",
		"nps": "NPS",
		"divider": "Avdelare",
		"page_break": "Sidbrytning",
		"paragraph": "Stycke",
		"textarea": "Fler-radigt textfält",
		"start_by_dragging_elements": "Börja med att dra fält från kolumnen till höger.",
		"no_translation": "Översättning saknas",
		"remove_field": "Ta bort fält",
		"really_remove_field": "Vill du verkligen ta bort detta fält?",
		"reports_guide": "Rapporter",
		"settings_guide": "Redigera undersökningens allmänna inställningar, aktivitet och utseende.",
		"placeholder": "Platshållare",
		"add_field": "Lägg till fält",
		"min": "Minimum",
		"max": "Maximum",
		"drop_here": "Släpp här",
		"options": "Alternativ",
		"add_option": "Lägg till alternativ",
		"option_label": "Alternativtext",
		"select_one": "Välj ett",
		"finnish": "Finska",
		"english": "Engelska",
		"swedish": "Svenska",
		"en": "Engelska",
		"fi": "Finska",
		"select_many": "Välj flera",
		"survey_heading": "Enkätens rubrik",
		"only_used_internally": "Endast för internt bruk, visas inte för respondenter.",
		"enabled": "På",
		"disabled": "Av",
		"scheduled": "Schemalagd",
		"scheduling_survey": "Schemalägger enkät",
		"schedule_survey": "Schemalägg enkät",
		"unsaved_changes": "Du har osparade ändringar",
		"custom_css": "Anpassad CSS",
		"custom_css_guide": "Du kan anpassa enkätens stilar manuellt genom att skriva CSS. Dokumentation om CSS finns online.",
		"general_settings": "Allmänna inställningar",
		"text_before_survey": "Text före enkäten",
		"text_after_survey": "Text efter enkäten",
		"survey_visuals": "Enkätens utseende",
		"color_scheme": "Färgschema",
		"logo": "Logotyp",
		"upload_logo": "Ladda upp logotyp",
		"survey_status": "Enkätstatus",
		"survey_not_found": "Enkäten hittades inte",
		"make_sure_link_is_correct": "Se till att länken har kopierats i sin helhet.",
		"start": "Starta",
		"submit": "Skicka svar",
		"check_answers": "Kontrollera svar",
		"open_survey": "Öppna enkät",
		"answer_sent": "Tack för ditt svar!",
		"content_and_languages": "Innehåll och språk",
		"visuals": "Enkätens utseende",
		"empty_base": "Tom mall",
		"previously_created_survey": "Tidigare skapad enkät",
		"select_base_for_survey": "Välj en mall för din enkät",
		"survey_internal_name": "Intern namn för enkät",
		"select_survey": "Välj enkät",
		"status_desc": "När en ny enkät skapas sätts status alltid till ”Aktiv”. Du kan ändra status på enkätens flik Inställningar.",
		"heading_and_before_text": "Rubrik och inledningstext",
		"heading_and_before_text_desc": "Enkätens rubrik och inledningstext visas på startsidan för enkäten under logotypen. Utan dessa uppgifter är enkätens startsida inte tillgänglig.",
		"after_text": "Sluttext",
		"after_text_desc": "Sluttexten visas för respondenten efter att enkäten har besvarats.",
		"add_language": "Lägg till språk",
		"color_scheme_desc": "Enkätens färgtema bestämmer färgen på knappar och flervalsfält.",
		"logo_desc": "Logotypen visas överst på varje enkät-sida.",
		"recommended_size": "Rekommenderad storlek",
		"recommended_size_desc": "Horisontell, 300px bred",
		"max_file_size": "Maximal filstorlek",
		"allowed_extensions": "Tillåtna filformat",
		"coming_soon": "Kommer snart",
		"remove_language": "Ta bort språk",
		"save_all_settings": "Spara alla inställningar",
		"survey_not_fillable": "Enkäten har inga ifyllbara fält.",
		"min_options": "Välj minst {{count}}",
		"max_options": "Du kan välja högst {{count}}",
		"saving": "Sparar...",
		"current_changes_might_not_be_saved": "De senaste ändringarna kanske inte har sparats.",
		"remove_survey_submissions": "Ta bort svar",
		"really_remove_survey_submissions": "Är du säker på att du vill ta bort de valda svaren?",
		"survey_not_fillable_time": "Enkäten är inte öppen",
		"items": "Objekt",
		"invalid_discount_code": "Ogiltig rabattkod",
		"remove_discount_code": "Ta bort rabattkod",
		"looking_for_old_tavoittaja": "Letar du efter äldre tavoittaja?",
		"fill_at_least_one_field": "Svara på minst ett fält",
		"contact_us_to_order": "Kontakta oss för att beställa",
		"is_invoicing_enabled": "Kontot kan köpa krediter mot faktura",
		"used_times": "Användningstillfällen",
		"link_to_survey": "Länk till enkät",
		"add_survey_link": "Lägg till enkätlänk",
		"remove_surveys": "Ta bort enkäter",
		"really_remove_surveys": "Vill du verkligen ta bort de valda enkäterna?",
		"is_summary_page_shown": "Visa sammanfattning av inlämningen som sista sida",
		"select_at_least": "Välj minst",
		"select_maximum": "Välj högst",
		"field_type": "Fälttyp",
		"one_line": "Enradigt textfält",
		"text_area": "Flerradigt textfält",
		"country": "Land",
		"procountor_business_partner_identifier": "Procountor Business Partner Identifier",
		"e_invoice_address": "E-fakturaadress",
		"e_invoice_intermediate_id": "Mellan-ID",
		"invoice_reference": "Referens / Kostnadsställe",
		"contact": "Kontakt",
		"credits_at_the_moment": "Krediter för tillfället",
		"submission": "Inlämning",
		"user_guide": "Användarguide",
		"basic_details": "Grundläggande uppgifter",
		"invoicing_details": "Faktureringsuppgifter",
		"remove_survey_submission": "Ta bort svar",
		"really_remove_survey_submission": "Är du säker på att du vill ta bort detta svar?",
		"missing_required_fields": "Fyll i alla obligatoriska fält även för de andra språken.",
		"credit_usage_pricing": "Kreditanvändning vid utskick",
		"message_length": "Meddelandelängd",
		"price_per_message": "Använda krediter per meddelande",
		"location": "Plats",
		"finland": "Finland",
		"nordics_and_baltic": "Norden och Baltikum",
		"usa_and_rest_of_europe": "USA och övriga Europa",
		"credit_usage_desc": "Kreditanvändning baseras på innehållets längd, så meddelandet du skickar kan i praktiken bestå av flera meddelanden. I tabellen nedan ser du hur längden påverkar kreditanvändningen.",
		"above_only_for_finland": "Obs! Tabellen ovan gäller inrikesmeddelanden (Finland)u. Nedan kan du se hur mottagarlandet påverkar kreditanvändningen.",
		"other_countries": "Andra länder",
		"credit_amount": "kreditmängd",
		"credits_lower_case": "krediter",
		"from_ui": "Från användargränssnittet",
		"from_import": "Från importerna",
		"api_message_history": "Meddandehistorik (API)",
		"sent_messages_guide_api": "Här kan du se information om meddelanden som skickats via API. Du kan se en detaljerad leveransrapport genom att klicka på ett meddelande. Mottagarinformationen sparas för innevarande och föregående kalenderår.",
		"set_billing_email": "Ange en fakturerings-e-post för ditt konto från menyn 'Konto' för att köpa krediter",
		"hidden": "Dold",
		"status_message": "Rått operatörsstatusmeddelande",
		"min_max_guide": "Med minimum och maximum kan du ange hur många alternativ en deltagare kan välja.",
		"old_email": "Ange den e-postadress du använde i den gamla versionen. Du kan lämna fältet tomt om du inte vet eller minns den.",
		"request_credit_transfer": "Jag begär att krediter överförs från den gamla versionen till den här versionen. Överföringen kommer att slutföras inom senast en arbetsdag.",
		"nothing_to_export": "Inga kontakter att exportera",
		"add_contact_to_preview": "Lägg till minst en kontakt för förhandsvisning",
		"pay": "Betala",
		"file_too_large": "Filen är för stor",
		"use_inbound_number": "Använd sändningsnummer",
		"api_documentation": "API-dokumentation",
		"automatic_credit_purchase": "Automatiskt kreditköp",
		"add_card": "Lägg till betalkort",
		"add_card_first": "Börja med att lägga till ett betalkort som kreditköpen ska debiteras från",
		"remove_api_key": "Ta bort API-nyckel",
		"really_remove_api_key": "Är du säker på att du vill ta bort API-nyckeln?",
		"no_api_keys_found": "Börja med att skapa en API-nyckel",
		"remove_card": "Ta bort kort",
		"automatic_credit_purchase_guide": "Med automatiska kreditköp kan du ställa in en minsta kreditsaldo för ditt konto. När ditt saldo sjunker till den nivån fyller systemet automatiskt på med det antal krediter du valt.",
		"really_remove_card": "Är du säker på att du vill ta bort kortet? Automatiska kreditköp kommer att sluta fungera.",
		"auto_purchase_credit_threshold": "Minsta saldo då krediter köps",
		"auto_purchase_credit_amount": "Belopp som ska köpas",
		"api_keys": "API-nyckeln",
		"buyer": "Köpare:",
		"place_order": "Beställ krediter",
		"really_place_order": "Vill du verkligen beställa krediter?",
		"auto_purchase_settings": "Inställningar",
		"always_active": "Minsta saldo vid vilket krediter köps",
		"always_active_desc": "När du använder krediter och ditt saldo sjunker till denna nivå eller lägre, köper systemet automatiskt det antal krediter du har angett. Systemet köper fler krediter om SMS-meddelandet kräver mer än det belopp du har valt.",
		"is_automatic_payments_enabled": "Automatiskt krediterköp aktiverat",
		"card_accepted": "Kortet godkändes",
		"card_declined": "Kortet avslogs",
		"successful_imports": "Lyckade rader",
		"skipped_imports": "Hoppade över rader",
		"failed_imports": "Misslyckade rader",
		"import_details": "Importdetaljer",
		"import_status_message": "Felmeddelande",
		"line_number": "Radnummer",
		"time_imported": "Importerad",
		"skipped": "Hoppad över",
		"completed": "Slutförd",
		"error": "Fel",
		"we_do_not_store_card_info": "Mottagaren lagrar inte betal­kortsinformation.",
		"payment_provider": "Betaltjänstleverantören är Paytrail",
		"send_notification_email": "Jag vill få en e-postavisering när importen är klar",
		"non_valid_email_will_be_skipped": "Om e-postadressen inte är giltig importeras raden utan den.",
		"no_import_rows": "Inga rader att importera",
		"following_are_invalid": "Ogiltiga nummer",
		"bar": "Stapeldiagram",
		"line": "Linjediagram",
		"total_this_year": "Totalt i år:",
		"month": "Månad",
		"average_per_month": "Genomsnitt per månad",
		"request_invoicing": "Begär faktureringsrättigheter",
		"interested_in_invoicing": "Kan jag betala med faktura?",
		"really_request_invoicing": "Om du vill betala kreditbeställningar med faktura, skicka en begäran via knappen nedan. Vi kontaktar dig så snart som möjligt.",
		"really_request_invoicing_invoice_fee": "Faktureringsavgiften är 9,90 € per styck.",
		"send_invoicing_request": "Begär faktureringsrättigheter",
		"thank_you_we_will_contact_you_soon": "Tack! Vi kontaktar dig så snart som möjligt.",
		"order_status": "Orderstatus",
		"send_survey_via_message": "Skicka undersökning via meddelande",
		"add_new_custom_field": "Lägg till nytt anpassat fält",
		"all_on_page_selected": "Alla rader på den här sidan är markerade.",
		"all_selected": "Alla rader är markerade.",
		"clear_selection": "Rensa markeringar",
		"invoice_contact_name": "Faktureringskontaktperson",
		"invoice_delivery_method": "Fakturaleveranssätt",
		"e_invoice": "E-faktura",
		"discount_code": "Använt rabattkod",
		"purchaser_name": "Köparens namn",
		"checkout_payment_status": "Checkout-betalningsstatus (Paytrail)",
		"add_individual_recipients": "Lägg till enskilda mottagare",
		"or_add_new_contacts": "Lägg till nya kontakter",
		"confirm_adding_new_contacts": "Bekräfta att du vill lägga till nya kontakter",
		"choose_from_existing": "Eller välj från befintliga kontakter",
		"add_recipient_groups": "Lägg till mottagargrupper",
		"these_amounts_are_only_expected_amounts": "Beloppen ovan är uppskattningar. Du ser de slutliga siffrorna i nästa steg.",
		"special_characters_found": "Obs! Ditt meddelande innehåller specialtecken som kan göra att det förbrukar fler krediter:",
		"encoding": "Kodning",
		"message_count": "Skickas som {{count}} separat(a) meddelande(n) på grund av dess längd",
		"remove_scheduling": "Ta bort schemaläggning och ändra meddelandet till ett utkast",
		"remove_scheduling_and_send_now": "Ta bort schemaläggning och skicka nu",
		"really_send_scheduled_message_now": "Meddelandet skickas omedelbart till {{count}} mottagare. Vill du fortsätta?",
		"delivery_report_url": "Webhook-URL för leveransrapport",
		"time_received_after": "Mottaget efter",
		"false": "Nej",
		"choose_multiple": "Flerval",
		"ui": "Användargränssnitt",
		"duplicate_account": "Konto finns redan med företags-ID",
		"duplicate_account_verify": "Ett konto med detta organisationsnummer finns redan. Vill du ändå godkänna detta konto?",
		"enable": "Aktivera automatisk köp av krediter",
		"choose_payment_method": "Välj betalningsmetod",
		"remove_payment_method": "Ta bort betalningsmetod",
		"really_remove_payment_method": "Är du säker på att du vill ta bort denna betalningsmetod?",
		"contact_first_name": "Kontaktens förnamn",
		"contact_last_name": "Kontaktens efternamn",
		"contact_full_name": "Kontaktens fullständiga namn",
		"contact_phone": "Kontaktens telefonnummer",
		"contact_company": "Kontaktens företag",
		"webhook_secret": "Webhook secret",
		"sv": "Svenska",
		"inbound_number_documentation": "Dokumentation",
		"decline_reason": "Orsak till avstängning/avslag",
		"allowed_characters": "Ett registrerat namn eller nummer. Du kan också använda tjänstens registrerade avsändarnamn Tavoittaja.",
		"use_international_format": "Om du använder ett mobilnummer som avsändarnamn, ange numret i internationellt format +358501234567.",
		"you_can_also_use_inbound_number": "Du kan också använda ett 2-vägs sändningsnummer, vilket tillåter svar på meddelanden.",
		"add_recipients_law_guide_1": "Att skicka textmeddelanden faller under finsk lagstiftning och räknas som marknadsföringskommunikation.",
		"add_recipients_law_guide_2": "Du får inte skicka textmeddelanden till privatpersoner utan deras **förhandsgodkännande**.",
		"add_recipients_law_guide_3": "Du kan läsa mer om lagstiftningen på Transport- och kommunikationsministeriets webbplats.",
		"remove_imports": "Ta bort importer från historiken",
		"really_remove_imports": "Är du säker på att du vill ta bort de valda importerna från historiken? Detta tar inte bort de importerade kontakterna.",
		"import_rows": "Importera rader",
		"mapping_fields": "Kolumner",
		"open_contact": "Visa kontaktuppgifter",
		"previously_used": "Tidigare använda",
		"you_previously_used": "Använd tidigare använd avsändare: {{number}}",
		"allowed_traficom_sender_names": "Avsändarnamn som normalt blockeras av Traficom men tillåtna för detta konto",
		"other": "Andra",
		"separate_multiple_names_with_commas": "Separera flera namn med kommatecken",
		"change_status": "Ändra kontakters status",
		"we_recommend_turning_on_automatic_payments": "Vi rekommenderar att du aktiverar automatisk kreditpåfyllning. På så sätt slipper du riskera att få slut på krediter av misstag",
		"phone_must_be_10_char": "Telefonnumret måste vara minst 10 siffror långt inklusive landskoden.",
		"expires_in": "Går ut till",
		"maybe_dont_use_spaces": "Om du skickar meddelanden utomlands rekommenderar vi att du inte använder mellanslag, eftersom alla utländska operatörer inte stöder dem.",
		"order_rows": "Orderrader",
		"info_about_admin_role": "Admin kan lägga till och ta bort användare.",
		"placeholder_in_use": "Antalet krediter är en uppskattning eftersom meddelandet har anpassats. Du kommer att se det exakta antalet i nästa steg.",
		"buy_more_credits": "Köp fler krediter",
		"exporting_rows": "Exporterar {{count}} rader",
		"export_count": "Exportera till Excel ({{count}})",
		"sending_status": "Skickningsstatus",
		"delivered": "Levererad",
		"processing": "Väntar på leverans",
		"failed": "Misslyckades",
		"message_preferences": "Meddelandeinställningar",
		"is_informational_messages_allowed": "Jag vill ta emot informationsmeddelanden",
		"is_marketing_messages_allowed": "Jag vill ta emot marknadsföringsmeddelanden",
		"user": "Användaruppgifter",
		"users_guide_tab": "",
		"this_will_send_emails_to_all_account_users": "Om du aktiverar detta skickas ett e-postmeddelande till alla kontoanvändare som har godkänt informationsmeddelanden.",
		"is_active": "Aktiv på kontot {{account}}",
		"is_not_active": "Inte i bruk",
		"comment": "Kommentar",
		"add_automatic_payment_method": "Lägg till en till",
		"add_payment_method": "Lägg till automatisk betalningsmetod",
		"card": "Kort",
		"add_comment": "Lägg till kommentar",
		"external_id": "Externt ID",
		"sender_name_type": "Avsändarnamnstyp",
		"authorization_level": "Auktoriseringsnivå",
		"company_name": "Företagsnamn",
		"company_website": "Företagets webbplats",
		"contact_person_name": "Kontaktpersonens namn",
		"purposes": "Syften",
		"primary_purpose": "Huvudsyfte",
		"secondary_purpose": "Sekundärt syfte",
		"tertiary_purpose": "Tertiärt syfte",
		"none": "Ingen",
		"trust": "Förtroende",
		"transactional": "Transaktionell",
		"promotional": "Marknadsföring",
		"alphanumeric": "Alfanumerisk",
		"registered": "Registrerad",
		"authorized": "Auktoriserad",
		"processing_prospectum": "Bearbetar Prospectum",
		"processing_my_link": "Bearbetar MyLink",
		"reject_reason": "Orsak till avslag",
		"create_sender_name": "Skapa avsändarnamn",
		"edit_sender_name": "Redigera avsändarnamn",
		"created": "Skapades framgångsrikt",
		"updated": "Uppdaterades framgångsrikt",
		"sender_names": "Avsändarnamn",
		"sender_names_guide": "Enligt Traficoms nya föreskrift (28 L/2025) måste alla aktörer som skickar textmeddelanden auktorisera sina avsändar-ID:n. Meddelanden som skickas med ett icke auktoriserat avsändar-ID kan levereras med avsändarnamnet visat som 'Okänd'. Auktorisering är kostnadsfri för våra kunder och behandlas inom 10 arbetsdagar.",
		"add_sender_name": "Lägg till avsändarnamn",
		"no_sender_names_found": "Inga avsändarnamn hittades",
		"remove_sender_names": "Ta bort avsändarnamn",
		"really_remove_sender_names": "Vill du verkligen ta bort alla valda avsändarnamn?",
		"tell_us_your_sender_name": "I Tavoittaja kan avsändarnamn godkännas kostnadsfritt",
		"after_46_will_be_unknown": "Vi har beslutat att nya godkännanden är gratis för våra kunder. Godkännanden behandlas inom 10 arbetsdagar.",
		"read_info_sender_name": "Läs informationen",
		"sender_name": "Avsändarnamn",
		"sender_name_case_sensitive": "Auktoriseringen är skiftlägeskänslig (t.ex. är \"Tavoittaja\" och \"TAVOITTAJA\" olika avsändarnamn). Skriv avsändarnamnet exakt så som du vill att det ska visas för mottagaren.",
		"sender_name_cannot_be_updated_anymore": "Detta avsändarnamn behandlas redan och kan inte längre uppdateras.",
		"accepted": "Godkänd",
		"select_or_type_name": "Välj från listan eller skriv ett nytt",
		"senders_name": "Avsändarnamn eller nummer",
		"authorize_sender_name": "Auktorisera dina avsändarnamn",
		"maybe_later": "Kanske senare",
		"authorize_now": "Auktorisera nu (detta meddelande har sparats)",
		"processing_s": "Bearbetar",
		"remove_sender_name": "Remove sender name",
		"really_remove_sender_name": "Really remove this sender name?",
		"is_your_sender_name_type_correct": "Är din avsändartyp korrekt?",
		"sender_name_looks_like_phone_number": "Du har angett typen som alfanumerisk, men namnet innehåller endast siffror (0–9), +-tecken och mellanslag, så det ser ut som ett telefonnummer.",
		"its_correct": "Det är korrekt – inte ett telefonnummer",
		"no_go_back": "Det är fel, gå tillbaka",
		"contact_name": "Kontaktens namn",
		"have_read_privacy_policy": "Jag har läst och accepterat ",
		"privacy_policy": "integritetspolicy",
		"privacy_policy_sidebar": "Integritetspolicy",
		"resend": "Skicka igen",
		"resend_message": "Skicka meddelandet igen",
		"really_resend_message": "Vill du verkligen skicka detta meddelande igen?",
		"message_sent": "Meddelandet har skickats",
		"close_modal": "Stäng",
		"notice_when_sending_abroad": "Om du skickar meddelanden utomlands, observera att det finns olika begränsningar för avsändarnamn i olika länder. Se en vägledande lista",
		"here": "här",
		"contact_not_found": "Kontakt hittades inte",
		"contact_not_found_explanation": "Kontakten hittades inte eftersom den troligen har tagits bort.",
		"no_sender_names": "Inga godkända avsändarnamn",
		"account_has_no_sender_names": "Ditt konto har ännu inga godkända avsändarnamn. Auktorisering krävs för att skicka meddelanden.",
		"authorize": "Auktorisera nu",
		"password_must_contain_uppercase_lowercase_and_number": "Lösenordet måste innehålla minst en versal, en gemen och en siffra.",
		"set_invoice_delivery_method": "Ange fakturans leveranssätt i kontoinställningarna",
		"invoicing_fee": "{{amount}} €"
	},
	"contacts": {
		"browse_contacts": "Bläddra i kontakter",
		"browse_contacts_desc": "Bläddra i alla kontakter",
		"add_contact": "Lägg till kontakt",
		"import_contacts": "Importera kontakter",
		"import_contacts_desc": "Importera nya eller uppdatera befintliga kontakter från filer.",
		"groups_desc": "Grupper hjälper dig att organisera kontakterna för enklare hantering",
		"add_group": "Lägg till grupp",
		"add_to_groups": "Lägg till i grupper",
		"import_name": "Importnamn",
		"create_new_group": "Skapa ny grupp",
		"create_new_group_desc": "Lägg till varje importerad kontakt i en vald grupp eller i flera grupper",
		"default_country_code": "Standard landskod",
		"default_country_code_desc": "Nummer som börjar med 0 ersätts som standard med denna kod",
		"import_only_new_contacts": "Importera endast nya kontakter",
		"import_only_new_contacts_desc": "Om detta är aktiverat uppdateras inte befintliga kontakter, endast nya läggs till.",
		"how_is_contact_data_updated": "Hur uppdateras kontaktuppgifter",
		"contact_data_update_desc": "Välj hur befintlig kontakts information ska uppdateras",
		"overwrite_old_data": "Skriv över gammal data",
		"add_only_new_properties": "Lägg till endast nya egenskaper",
		"is_first_row_header": "Är första raden en rubrik",
		"is_first_row_header_desc": "Om det första värdet i varje kolumn är en rubrik (t.ex. telefon eller e-post) bör detta aktiveras",
		"phone_number_is_needed_to_continue": "Du måste välja minst telefonnummerfält för att fortsätta",
		"import_process_started_in_background": "Importprocessen har startats i bakgrunden.",
		"import_status_refreshes_automatically": "Vyn uppdateras automatiskt när importen är klar.",
		"import_completed": "Importen är klar",
		"import_failed": "Importen misslyckades",
		"property_updating_method": "Metod för uppdatering av egenskaper",
		"is_importing_new_only": "Importerar endast nya",
		"imports_desc": "Bläddra och visa alla dina importer",
		"show_imports": "Visa importer",
		"contact_added": "Kontakt tillagd",
		"group_added": "Grupp tillagd"
	},
	"messages": {
		"time_sent_after": "Skickat efter",
		"time_sent_before": "Tid skickad före",
		"deliver_details": "Leveransuppgifter",
		"sending_in_progress": "Skickar pågår",
		"sending_failed": "Skickning misslyckades",
		"continue_to_choose_recipients": "Fortsätt till val av mottagare",
		"credit_cost": "Pris i krediter",
		"per_message": "per meddelande",
		"save_draft": "Spara utkast",
		"edit_message_content": "Redigera meddelandets innehåll",
		"choose_recipients": "Välj mottagare",
		"confirm_send": "Bekräfta sändning",
		"message_scheduled_successfully": "Meddelandet har schemalagts",
		"message_sending_started_successfully": "Sändningsprocessen har startats",
		"view_more_info_from_details": "Du kan se mer information om meddelandet och dess sändningsprocess genom att gå till meddelandets detaljer",
		"go_back_to_drafts": "Gå tillbaka till utkast",
		"go_to_message_details": "Gå till meddelandets detaljer",
		"time_is_required": "Tid är obligatorisk",
		"select_one_action": "Välj en åtgärd",
		"total_recipients": "Mottagare",
		"confirm_schedule": "Bekräfta schemalagd sändning",
		"select_from_existing_contacts": "Välj från befintliga kontakter",
		"name_is_for_internal_use": "Namnet är endast för internt bruk, det visas inte för mottagare",
		"you_will_run_out_of_credits": "Inte tillräckligt med krediter för schemalagda meddelanden",
		"scheduled_messages_out_of_credits": "Du har inte längre tillräckligt med krediter för dina schemalagda meddelanden – du saknar {{missingCredits}} krediter."
	}
}
